'use client';

import { Box, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';
import { color, borderRadius, spacing, breakpoints } from 'src/theme/tokens';
import { typography as dsTypography } from 'src/theme/typography';
import { Link } from 'src/i18n/routing';

const FooterContactWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    padding-right: ${spacing[0]};
    gap: ${spacing[16]};
    @media (min-width: ${breakpoints.sm}) {
        padding-right: ${spacing[24]};
    }
    @media (min-width: ${breakpoints.md}) {
        padding-right: ${spacing[32]};
    }
    @media (max-width: ${breakpoints.sm}) {
        max-width: calc(100vw - ${spacing[48]});
    }
`;

const Badge = styled(Box)`
    background: ${color.gray[80]};
    border-top-left-radius: ${borderRadius[16]};
    border-bottom-right-radius: ${borderRadius[16]};
    display: flex;
    align-items: center;
    height: 63px;
    padding: 0 ${spacing[20]};
    box-sizing: border-box;
    max-width: 416px;
    @media (max-width: ${breakpoints.md}) {
        max-width: 316px;
    }
    @media (max-width: ${breakpoints.sm}) {
        max-width: 100%;
    }
`;

const Copy = styled(Typography)`
    font-weight: 400;
    font-size: 15px;
    line-height: 1.5;
    color: ${color.white[0]};
`;

const Email = styled('span')(() => ({
    ...dsTypography.label5medium,
    color: color.white[0],
    textDecoration: 'underline',
}));

const FooterLink = styled(Link)`
    color: ${color.white[0]};
    text-decoration: none;
    &:visited {
        color: ${color.white[0]};
    }
    &:focus {
        outline: none;
    }
    &:focus-visible {
        outline: 2px solid ${color.white[0]};
        outline-offset: 2px;
    }
`;

export default function FooterContact() {
    const t = useTranslations();
    const email = 'mailto:cservice@w8shipping.com';

    return (
        <FooterContactWrapper >
            <Badge>
                <Typography variant="heading1bold" component="h2" color={color.white[0]}>{t('Footer.service.title')}</Typography>
            </Badge>
            <Box>
                <Copy>{t('Footer.service.copy')}</Copy>
                <FooterLink href={email}>
                    <Email>{t('Footer.service.emailLabelAlt')}</Email>
                </FooterLink>
            </Box>
        </FooterContactWrapper>
    );
}


